import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { PageLoadingSpinner } from '@jobmatchme/ui';
import { FormattedMessage } from 'react-intl';
import styles from './style.module.scss';
import { withStyles } from '@material-ui/core/styles';

var tableStyles = function tableStyles(theme) {
  return {
    head: {
      backgroundColor: '#fff',
      position: 'sticky',
      top: 0
    }
  };
};
/**
 * materialUi table with support for sorting
 */


var SortingTable = function SortingTable(_ref) {
  var rows = _ref.rows,
      tableHeads = _ref.tableHeads,
      onRowClick = _ref.onRowClick,
      loading = _ref.loading,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? true : _ref$footer,
      _ref$perPage = _ref.perPage,
      perPage = _ref$perPage === void 0 ? 10 : _ref$perPage,
      classes = _ref.classes;

  var _useState = useState('asc'),
      _useState2 = _slicedToArray(_useState, 2),
      order = _useState2[0],
      setOrder = _useState2[1];

  var _useState3 = useState('name'),
      _useState4 = _slicedToArray(_useState3, 2),
      orderBy = _useState4[0],
      setOrderBy = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      page = _useState6[0],
      setPage = _useState6[1];

  var tableRows = rows;
  /**
   * default page size
   */

  var _useState7 = useState(perPage),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1];

  var tableHeaders = tableHeads;
  /**
   * sort the table data
   */

  var tableSort = function tableSort(array, cmp) {
    var stabilizedThis = array.map(function (el, index) {
      return [el, index];
    });
    stabilizedThis.sort(function (a, b) {
      var order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(function (el) {
      return el[0];
    });
  };

  var sortingDesc = function sortingDesc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }

    if (b[orderBy] > a[orderBy]) {
      return 1;
    }

    return 0;
  };

  var getSorting = function getSorting(order, orderBy) {
    return order === 'desc' ? function (a, b) {
      return sortingDesc(a, b, orderBy);
    } : function (a, b) {
      return -sortingDesc(a, b, orderBy);
    };
  };

  var handleChangePage = function handleChangePage(event, newPage) {
    setPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
  };

  var sortHandler = function sortHandler(property) {
    return function (event) {
      var isDesc = orderBy === property && order === 'desc';
      setOrder(isDesc ? 'asc' : 'desc');
      setOrderBy(property);
    };
  };

  var renderCol = function renderCol(value) {
    return React.createElement(TableCell, {
      key: Math.random(),
      className: styles.col,
      scope: "row"
    }, value);
  };

  var renderCols = function renderCols(cols) {
    var renderedCols = [];
    Object.values(tableHeads).map(function (value) {
      return renderedCols.push(renderCol(cols[value.field]));
    });
    return renderedCols;
  };

  return React.createElement(React.Fragment, null, loading && React.createElement("div", {
    className: styles.loading
  }, React.createElement(PageLoadingSpinner, {
    fullHeight: true
  })), React.createElement(Table, {
    className: styles.table
  }, React.createElement(TableHead, {
    className: styles.tableHead
  }, React.createElement(TableRow, null, tableHeaders.map(function (head) {
    return React.createElement(TableCell, {
      className: styles.col + ' ' + classes.head,
      align: "left",
      key: Math.random(),
      sortDirection: orderBy === head.headId ? order : false
    }, React.createElement(TableSortLabel, {
      active: orderBy === head.orderId,
      direction: order,
      onClick: sortHandler(head.orderId)
    }, React.createElement(FormattedMessage, {
      id: head.headId,
      defaultMessage: head.title
    })));
  }))), React.createElement(TableBody, null, tableSort(tableRows, getSorting(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (row) {
    return React.createElement(TableRow, {
      className: styles.row,
      key: Math.random(),
      onClick: function onClick() {
        onRowClick(row);
      }
    }, renderCols(row));
  }))), footer && React.createElement(TablePagination, {
    rowsPerPageOptions: [5, 10, 25, 50, tableRows.length],
    component: "div",
    count: rows.length,
    rowsPerPage: rowsPerPage,
    page: page,
    backIconButtonProps: {
      'aria-label': 'Vorherige Seite'
    },
    nextIconButtonProps: {
      'aria-label': 'Nächste Seite'
    },
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }));
};

export default withStyles(tableStyles)(SortingTable);